import React from 'react';

import useTab from '../../../store/hooks/useTab';
import TabBar from '../../../components/Tab/TabBar';
import Console from './Console';
import Dispatch from './Dispatch';
import Markets from './Markets';
import Licensing from './Licensing';
import Analytics from './Analytics';

const CONSOLE = 'console';
const DISPATCH = 'dispatch';
const MARKETS = 'markets';
const LICENSING = 'licensing';
const ANALYTICS = 'analytics';
const TABS = [CONSOLE, DISPATCH, MARKETS, LICENSING, ANALYTICS];

export default function Gridcap() {
  const selectedTab = useTab(TABS);

  return (
    <TabBar tabs={TABS} selectedTab={selectedTab}>
      <Console tab={CONSOLE} />
      <Dispatch tab={DISPATCH} />
      <Markets tab={MARKETS} />
      <Licensing tab={LICENSING} />
      <Analytics tab={ANALYTICS} />
    </TabBar>
  );
}